import * as actions from './constants';
import { AuthTenant } from '../../helpers/authentication';
import config from '../../helpers/config';
import { request } from '../../helpers/request';
import { MetricEditingState } from '../../components/futureSecurity/editMetric';

export function resetMetricsState() {
  return (dispatch: MetricsDispatchType) => {
    dispatch({ type: actions.RESET });
  }
}

export function setValidationError(error: any) {
  return (dispatch: MetricsDispatchType) => {
    dispatch({ type: actions.SET_VALIDATION_ERROR, response: { error } });
  }
}

export function clearValidationError() {
  return (dispatch: MetricsDispatchType) => {
    dispatch({ type: actions.CLEAR_VALIDATION_ERROR });
  }
}

export function getTerminals(location: AuthTenant) {
  const action: MetricsAction = { type: actions.LOAD_TERMINALS }
  return async (dispatch: MetricsDispatchType) => {
    try {
      dispatch({ type: actions.SET_LOADING_TERMINALS });
      const data = await request("GET", `${config.apiUrl}/future-security/terminals/${location}`);
      dispatch({ ...action, response: { terminals: data } });
    } catch (error) {
      dispatch({ ...action, response: { error } });
    }
  }
}

export function loadMetricDefinitions(location: AuthTenant, terminal?: string) {
  const action: MetricsAction = { type: actions.LOAD_METRIC_DEFINITIONS }
  return async (dispatch: MetricsDispatchType) => {
    try {
      if(!terminal) return
      dispatch({ type: actions.SET_LOADING_METRIC_DEFINITIONS })
      let loc = location as string
      const { metrics, lanes, cells} = await request("GET", `${config.apiUrl}/future-security/metrics/definitions/${loc}/${terminal}`)
      dispatch({ ...action, response: { metrics, cells, lanes }})
    } catch(error) {
      dispatch({ ...action, response: { error } });
    }
  }
}

export function updateTargets(metric: MetricDefinition, updateDetails: MetricEditingState, lanes: string[], isFallbackValues: boolean, terminal: string) {
  return async (dispatch: MetricsDispatchType) => {
    try {
      dispatch({ type: actions.SET_UPDATING_TARGET });
      const body = { metric, updateDetails, lanes, isFallbackValues, terminal };
      const data = await request('PUT', `${config.apiUrl}/future-security/update-target`, body);
      dispatch({ type: actions.UPDATE_TARGET, response: data})
    } catch (error) {
      const message = (error as unknown as Error).message
      console.log(message)
      dispatch({ type: actions.UPDATE_TARGET, response: { error: message } });
    }
  }
}

export function getSpecificMetric(metric: MetricDefinition, applyTo: string, dateTime: MetricEditingState, terminal: string) {
  const action: MetricsAction = { type: actions.GET_METRIC }
  return async (dispatch: MetricsDispatchType) => {
    try {
      const params = new URLSearchParams()
      params.append('target', JSON.stringify(dateTime))
      params.append('applyTo', applyTo)
      params.append('metric', JSON.stringify(metric))
      params.append('terminal', terminal)
      const data = await request('GET', `${config.apiUrl}/future-security/view-target?${params.toString()}`);
      dispatch({ ...action, response: data})
    } catch (error) {
      dispatch({ ...action, response: { error } });
    }
  }
}

export function deleteMetric(tenant: AuthTenant, job: MetricDefinition) {
  const action: MetricsAction = { type: actions.DELETE_METRIC };

  return async (dispatch: MetricsDispatchType) => {
    try {
      dispatch({ type: actions.SET_DELETING_METRIC });
      await request('DELETE', `${config.apiUrl}/recruitment/${job.code}?location=${tenant}`);
      dispatch({ ...action, response: { job } });
    } catch (error) {
      dispatch({ ...action, response: { error } });
    }
  }
}